<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 36 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M36 1.5v7.999c-0.002 0.828-0.673 1.498-1.501 1.498-0.414 0-0.788-0.167-1.060-0.438l-2.232-2.232-15.221 15.22c-0.271 0.271-0.646 0.439-1.061 0.439s-0.789-0.168-1.061-0.439l-1.414-1.414c-0.271-0.271-0.439-0.646-0.439-1.061s0.168-0.789 0.439-1.061l15.221-15.219-2.231-2.232c-0.271-0.271-0.438-0.646-0.438-1.060 0-0.828 0.67-1.499 1.497-1.501h7.999c0 0 0.001 0 0.001 0 0.828 0 1.499 0.671 1.499 1.499 0 0 0 0.001 0 0.001v-0zM25.439 16.925l-1.003 1.003c-0.269 0.27-0.436 0.643-0.438 1.055v9.018h-19.998v-20.001h16.5c0.001 0 0.001 0 0.002 0 0.413 0 0.788-0.167 1.059-0.438l1.003-1.003c0.271-0.271 0.439-0.646 0.439-1.060 0-0.828-0.671-1.5-1.499-1.5h-18.504c-1.657 0-3 1.343-3 3 0 0 0 0.001 0 0.001v-0 22c0 1.657 1.343 3 3 3v0h22.002c1.657 0 3-1.343 3-3v0-11.015c0-0 0-0.001 0-0.001 0-0.829-0.672-1.5-1.5-1.5-0.415 0-0.791 0.169-1.063 0.441l-0 0z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
